export default {
  labels: {
    refunded: 'Payment refunded',
  },
  buttons: {
    show_payments: 'show payments',
    hide_payments: 'hide payments',
  },
};